import { render, staticRenderFns } from "./BanksIntegrationsList.vue?vue&type=template&id=585b6aca&"
import script from "./BanksIntegrationsList.vue?vue&type=script&lang=js&"
export * from "./BanksIntegrationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports